let module = angular.module('app.directives.checkout', []);

require('./checkout-add-ons');
require('./checkout-billing-address');
require('./checkout-final');
require('./checkout-order-summary');
require('./checkout-payment-method');
require('./checkout-shipping-address');

export default module;



// WEBPACK FOOTER //
// ./app/directives/checkout/index.js